// extracted by mini-css-extract-plugin
export default {"providers":"GroupPermissionPicker_providers__ga-gT"};